// db/recipients.ts
var Recipient = class {
  constructor(to, cc, bcc, replyTo, sender) {
    this.to = Array.isArray(to) ? to : [to];
    this.cc = cc ? Array.isArray(cc) ? cc : [cc] : void 0;
    this.bcc = bcc ? Array.isArray(bcc) ? bcc : [bcc] : void 0;
    this.replyTo = replyTo;
    this.sender = sender;
  }
};
export {
  Recipient
};
